import type * as CSS from 'csstype';

import getTheme from './getTheme';
import type { Brand } from '../types/brand';
import type { Color } from '../types/color';
import type { Utility } from '../types/utility';

interface GetColorProps {
  /** The color you want to translate
   * coolGrey.100 => return theme color
   */
  color?: Color.ValueKeys | CSS.Property.Color | Utility.ProductColorMap;
  /** The fallback color if color doesn't exist in the theme.
   * @default 'primary'
   */
  fallbackColor?: Color.ValueKeys | CSS.Property.Color;
  /** The theme object to translation colors from. */
  theme: Brand;
}

const getColor = ({ color, fallbackColor = 'primary', theme }: GetColorProps): string | undefined => {
  if (color === 'transparent') return color;

  const productColor = typeof color === 'object' ? theme.colors.productColor(color) : color;

  if (productColor?.includes('.')) return `${getTheme(`colors.${productColor}`, `${fallbackColor}`)({ theme })}`;

  if (productColor === 'primary' || productColor === 'secondary' || productColor === 'tertiary')
    return `${getTheme(`colors.${productColor}`, `${fallbackColor}`)({ theme })}`;

  return productColor;
};

export default getColor;
